<template>
  <div class="stake-table-container" :class="{'a-vs-main--grid-row__grid-col--table merged-table': isLess}">
    <div class="a-vs-c--label a-vs-c--label__icon">
      <h4>{{ $t(title) }}</h4>
    </div>

    <div class="a-vs-main--row__table--result-grid">
      <div class="a-vs-b--row a-vs-b--inner-labels" v-if="isLess">
        <div class="a-vs-b--row__col single-field" :class="{'field-selected': isLessSeleted}">
          <img :src="getArrowDown" alt="down">
          <span>{{$t('less')}}</span>
        </div>
        <div class="a-vs-b--row__col single-field" :class="{'field-selected': isMoreSeleted}">
          <img :src="getArrowUp" alt="up">
          <span>{{$t('more')}}</span>
        </div>
      </div>
      <div v-if="isLess">
          <div class="merged-table__body">
          <div class="a-vs-b--left-table">
            <div class="a-vs-b--row">
              <div class="a-vs-b--row__col single-field" :class="{'field-selected': activeStake === stake}"
              v-for="stake in stakesForLess" :key="stake.ID"
              @click="selectedItem(stake, 3)">
                <span class="result">{{ stake.Title }}</span>
                <span class="odds">{{ format(stake.Factor)}}</span>
              </div>
            </div>
          </div>

          <div class="a-vs-b--right-table">
            <div class="a-vs-b--row">
              <div class="single-field" :class="{'field-selected': activeStake === stake}"
              v-for="stake in stakesForMore" :key="stake.ID" @click="selectedItem(stake, 4)">
                <span class="result">{{ stake.Title }}</span>
                <span class="odds">{{ format(stake.Factor)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="a-vs-b--row" v-for="(row, indexRow) in stakesTable" :key="indexRow">
          <div v-for="stake in row"
            :key="stake.ID"
            class="single-field"
            :class="{'field-selected' :activeStake === stake}"
            @click="selectedItem(stake)">
              <span class="result">{{ stake.Title }}</span>
              <span class="odds">{{ format(stake.Factor) }}</span>
          </div>
        </div>
      </div>

      <div class="bet-placed" v-if="showOverlay && !isFullTimeHalfTime">
        <img :src="overlayImage" alt="bet-placed">
      </div>
    </div>
    <div class="no-more-bets" v-if="showOverlay && isFullTimeHalfTime">
      <img :src="overlayImage" alt="no-more-bets">
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/main.js'
import VSoccerStakeHelper from '@/mixins/VSoccerStakeHelper'
import LanguageHelper from '@/mixins/LanguageHelper'
import NumberFormat from '@/mixins/NumberFormat'

import vuexStore from '../../../store/vuexStore'

import selectBet from '../../../assets/audio/vSoccer/select_bet.mp3'

export default {
  mixins: [VSoccerStakeHelper, LanguageHelper, NumberFormat],
  props: {
    // HalfTime -1, FullTime -2, More -3, Less -4, CorrectScore -5
    type: {
      type: Number,
      required: true
    },
    matchNo: {
      type: Number
    },
    isBetPlaced: {
      type: Boolean,
      default: false
    },
    isBettingEnabled: {
      type: Boolean,
      default: true
    },
    activeStake: {
      type: Object
    },
    stakes: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  mounted () {
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  methods: {
    format: function (value) {
      return this.formatNumber(value / 100, this.getLanguageCodeForNumbers())
    },
    selectedItem: function (stake, selectedStake) {
      if (this.hasAudioEnabled) {
        var audio = new Audio(selectBet)
        audio.play()
      }
      if (!this.isBetPlaced) {
        eventBus.onSelectedStakeVSoccer(stake)
      }
    }
  },
  computed: {
    stakesForLess: function () {
      return this.prepareStakesForLess(this.stakes)
    },
    stakesForMore: function () {
      return this.prepareStakesForMore(this.stakes)
    },
    stakesForCorrectScore: function () {
      return this.prepareStakesForCorrectScore(this.stakes)
    },
    isMoreSeleted: function () {
      for (let i = 0; i < this.stakesForMore.length; i++) {
        if (this.activeStake === this.stakesForMore[i]) {
          return true
        }
      }
      return false
    },
    isLessSeleted: function () {
      for (let i = 0; i < this.stakesForLess.length; i++) {
        if (this.activeStake === this.stakesForLess[i]) {
          return true
        }
      }
      return false
    },
    isMore: function () {
      return this.type === 4
    },
    isLess: function () {
      return this.type === 3
    },
    isFullTimeHalfTime: function () {
      return this.type === 1 || this.type === 2
    },
    stakesTable: function () {
      switch (this.type) {
        case 1:
        case 2:
          return this.prepareStakesForFullTimeAndHalfTime(this.type, this.stakes)
        case 3:
          return this.stakesForLess
        case 4:
          return this.stakesForMore
      }
      return this.stakesForCorrectScore
    },
    title: function () {
      switch (this.type) {
        case 1:
          return 'half_time'
        case 2:
          return 'full_time'
        case 3:
        case 4:
          return 'sum_of_goals'
      }
      return 'correct_score'
    },
    subtitle: function () {
      if (this.isMore) {
        return 'more'
      } else if (this.isLess) {
        return 'less'
      } else {
        return ''
      }
    },
    getArrowUp: function () {
      return 'https://cloud.aleacontrol.com/media/vSoccer/arrow-up.png'
    },
    getArrowDown: function () {
      return 'https://cloud.aleacontrol.com/media/vSoccer/arrow-down.png'
    },
    overlayImage: function () {
      if (!this.isBettingEnabled) {
        return 'https://cloud.aleacontrol.com/media/vSoccer/no-more-bets.png'
      }
      if (this.isBetPlaced) {
        return 'https://cloud.aleacontrol.com/media/vSoccer/bet-placed.png'
      }
      return ''
    },
    showOverlay: function () {
      return !this.isBettingEnabled || this.isBetPlaced
    }
  }
}
</script>

<style scoped>
</style>
